module.exports = __webpack_public_path__ + "static/media/gosend.610ad47d.png";